import React from "react";
import { CircularProgress, Switch } from "@mui/material";
import { format, parseISO } from "date-fns";
import { pl } from "date-fns/locale";
import "./KarnetSection.scss";
import EAQuantitySelector from "../../../../shared/QuantitySelector/EAQuantitySelector";

interface IProps {
  enabled: boolean;
  onToggle: (value: boolean) => void;
  clampedRepeats: number;
  onRepeatsChange: (value: number) => void;
  horizonCount: number;
  lastAvailableDateLabel: string;
  loading: boolean;
  perTermPrice: number;
}

const KarnetSection: React.FC<IProps> = ({
  enabled,
  onToggle,
  clampedRepeats,
  onRepeatsChange,
  horizonCount,
  lastAvailableDateLabel,
  loading,
  perTermPrice,
}) => {
  const horizonLabel = lastAvailableDateLabel ? format(parseISO(lastAvailableDateLabel), "dd.MM.yyyy", { locale: pl }) : "";
  const maxRepeats = horizonCount > 0 ? horizonCount : 1;

  return (
    <div className={`karnet-section ${enabled ? "karnet-section--enabled" : ""}`}>
      <div className="karnet-section__header">
        <div className="karnet-section__header-text">
          <strong>Kup karnet — powtarzaj co tydzień</strong>
          <span>Ten sam dzień i godzina, ten sam zestaw biletów</span>
        </div>
        <Switch checked={enabled} onChange={(e) => onToggle(e.target.checked)} color="primary" />
      </div>

      {enabled && (
        <div className="karnet-section__body">
          <div className="karnet-section__stepper">
            <span className="karnet-section__stepper-label">Liczba terminów</span>
            <div className="karnet-section__stepper-control">
              <EAQuantitySelector
                value={clampedRepeats}
                onChange={onRepeatsChange}
                min={1}
                max={maxRepeats}
                disabled={loading}
                incrementDisabled={loading}
                decrementDisabled={loading}
              />
              {loading && <CircularProgress className="karnet-section__stepper-spinner" size={16} thickness={5} />}
            </div>
          </div>

          {loading ? (
            <p className="karnet-section__hint karnet-section__hint--loading">
              <CircularProgress size={14} thickness={5} />
              Sprawdzam dostępność kolejnych terminów…
            </p>
          ) : (
            horizonCount > 0 && (
              <p className="karnet-section__hint">
                Grafik otwarty do {horizonLabel} — możesz kupić maks. {horizonCount}{" "}
                {horizonCount === 1 ? "kolejny termin" : "kolejnych terminów"}.
              </p>
            )
          )}

          <div className="karnet-section__summary">
            {perTermPrice.toFixed(2)} zł × {clampedRepeats} {clampedRepeats === 1 ? "termin" : "terminy"}
            <strong>{(perTermPrice * clampedRepeats).toFixed(2)} zł</strong>
          </div>

          {/* <p className="karnet-section__disclaimer">
            Karnet nie daje zniżki — daje pewne miejsce w każdym tygodniu, o tej samej porze.
          </p> */}
        </div>
      )}
    </div>
  );
};

export default KarnetSection;
